module.exports = __webpack_public_path__ + "0fd183ecc2bb80588f4de36aff6940d7.png";